import clsx from "clsx";
import { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import { PulseLoader } from "react-spinners";
import { ArrowSmallDownIcon } from "../../../assets";
import {
  Button,
  CheckBox,
  PageItem,
  RequestItem,
  SearchInput,
} from "../../../components";
import { IRequest } from "../../../models";
import { getRequests } from "../../../services/request.service";
import styles from "./styles.module.scss";
import InfluencerItem from "../../../components/InfluencerItem";
import { useDebounce } from "../../../hooks";
import { searchPropositions } from "../../../services/propositions.service";
import PaginationButtons from "../../../components/PaginationButtons";
import { IPropositions } from "../../../models/IPropositions";

const limit = 20;

const Influencers: FC = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState<"Candidate" | "Employer">(
    "Candidate"
  );
  const [search, setSearch] = useState<string>("");
  const debounceSearch = useDebounce(search, 300);
  const page = useRef(1);
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [request, setRequest] = useState<IPropositions[]>([]);
  const [sort, setSort] = useState<-1 | 1>(-1);

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    page.current = 1;
    setSearch(e.target.value);
  };

  const onGetRequests = async () => {
    try {
      setIsLoading(true);

      const { data } = await searchPropositions(
        page.current,
        limit,
        sort,
        search
      );
      if (data?.success) {
        setPagesCount(Math.ceil(data?.count / limit));
        setRequest(data?.videos);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onGetRequests();
  }, [debounceSearch, sort]);

  return (
    <>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h4 className={styles.title}>Influencers</h4>
        </header>
        <section className={styles.contentContainer}>
          <div className={styles.searchContainer}>
            <SearchInput
              placeholder="Search"
              value={search}
              onChange={onChangeSearch}
            />
          </div>
          <div className={styles.sectionHeader}>
            <div className={styles.reporterBlock}>
              <p>Influencer</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.tagsBlock}>
              <p>Location</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.tagsBlock}>
              <p>Company</p> <ArrowSmallDownIcon />
            </div>
            <div
              onClick={() => setSort((prev) => (prev === 1 ? -1 : 1))}
              className={clsx(styles.dateBlock, {
                [styles.dateBlockActive]: sort === 1,
              })}
            >
              <p>Date added</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.statusBlock}>
              <p>Status</p> <ArrowSmallDownIcon />
            </div>
          </div>
          <div className={styles.reportsContainer}>
            {isLoading && (
              <div className={styles.loaderWrapper}>
                <PulseLoader color={"#7D4AFB"} />
              </div>
            )}
            {!isLoading &&
              request.map((item, index) => {
                return <InfluencerItem item={item} key={index} />;
              })}
            {!isLoading && request?.length === 0 && (
              <div className={styles.emptyTitle}>
                There are no new influencers
              </div>
            )}
          </div>
          <PaginationButtons
            pagesCount={pagesCount}
            page={page.current}
            onPress={(index) => {
              page.current = index;
              onGetRequests();
            }}
          />
        </section>
      </div>
    </>
  );
};

export default Influencers;
